export const userLanguages = [
    { id: 'en', name: 'English' },
    { id: 'de', name: 'Deutsch' },
];